export function renderCommonRelation(commonRelation: number): import("react").ReactNode {
    if (commonRelation < 0) {
        return <span style={{ color: 'red', fontWeight: 'bold' }} >{commonRelation} %</span>
    } else {
        return <span style={{ color: 'green', fontWeight: 'bold' }} >{commonRelation} %</span>
    }
}
